import * as Yup from "yup";
import React, { useState } from "react";
import { AiTwotoneTool } from "react-icons/ai";
import { Formik } from "formik";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import { MdCheck, MdPermPhoneMsg } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";

import Accordion from "components/layout/Accordion";
import ContainedButton from "components/layout/form/containedButton";
import OutlinedButton from "components/layout/form/outlinedButton";
import RadioField from "components/layout/form/radioField";
import medidor from "assets/images/medidor.png";
import theme from "styles/theme";
import {
  registerValuesNewUnit,
  toggleNewUnitStep,
} from "store/actions/add-new-unit-actions";

import {
  ButtonsContainer,
  ContactCard,
  Contacts,
  Container,
  Error,
  FormContainer,
  Header,
  IconContact,
  ImageContainer,
  InforCardContact,
  InputsContainer,
  ModalContainer,
  ModalContent,
  ModalHeader,
  ModalStyle,
  PrimaryColumn,
  SelectorField,
} from "./styles";

const stepData = {
  hasGasReleased: {
    title: "Está com o gás liberado?",
    subTitle:
      "Informe se seu apartamento/loja já está com acesso ao gás para agilizar o seu cadastro:",
  },
  hasGasMeter: {
    title: "Possui medidor?",
    subTitle: "Verifique o exempo a seguir",
  },
};

const Meter = (): JSX.Element => {
  const [isSelected, setIsSelected] = useState<boolean>();
  const [step, setStep] = useState("hasGasReleased");
  const [isShowModal, setIsShowModal] = useState(false);
  const dispatch = useDispatch();
  const addNewUnitReducer = useSelector(
    // @ts-ignore
    (state) => state.addNewUnitReducer
  );
  const { hasGasMeter, hasGasReleased } = addNewUnitReducer;

  const validatorSchemaGasMeter = (): any =>
    Yup.object().shape({
      hasGasMeter: Yup.string().required("É necessário selecionar uma opção"),
    });

  const validatorSchemaGasReleased = (): any =>
    Yup.object().shape({
      hasGasReleased: Yup.string().required(
        "É necessário selecionar uma opção"
      ),
    });

  const handleSubmitGasMeter = ({ hasGasMeter }): any => {
    setIsSelected(!!hasGasMeter);

    dispatch(registerValuesNewUnit({ hasGasMeter: hasGasMeter === "yes" }));
    dispatch(toggleNewUnitStep(2));
  };

  const handleSubmitGasReleased = ({ hasGasReleased }): void => {
    setIsSelected(!!hasGasReleased);

    dispatch(
      registerValuesNewUnit({ hasGasReleased: hasGasReleased === "yes" })
    );

    setIsShowModal(true);
  };

  const handleSubmitModal = ({ hasGasReleased }): void => {
    dispatch(
      registerValuesNewUnit({ hasGasReleased: hasGasReleased === "yes1" })
    );

    setIsShowModal(false);

    if (hasGasReleased === "yes1") {
      dispatch(registerValuesNewUnit({ hasGasMeter: true }));
      dispatch(toggleNewUnitStep(2));
    } else {
      setStep("hasGasMeter");
    }
  };

  return (
    <Container>
      <PrimaryColumn>
        <Header>
          <h1>{stepData[step].title}</h1>
        </Header>
        <span>{stepData[step].subTitle}</span>
        {step === "hasGasMeter" ? (
          <>
            <ImageContainer>
              <img
                src={medidor}
                alt="Exemplo de Medidor de gás"
                loading="lazy"
                aria-describedby="descimage"
              />
            </ImageContainer>
            <Formik
              initialValues={{
                hasGasMeter: hasGasMeter ? "yes" : "no",
              }}
              validationSchema={validatorSchemaGasMeter}
              onSubmit={handleSubmitGasMeter}
              render={({ handleChange, handleBlur, values }) => (
                <FormContainer>
                  <InputsContainer>
                    <SelectorField>
                      <RadioField
                        id="yes"
                        name="hasGasMeter"
                        value="yes"
                        type="radio"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        defaultChecked={hasGasMeter === true}
                      />
                      <label htmlFor="yes">Sim</label>
                    </SelectorField>
                    <SelectorField>
                      <RadioField
                        id="no"
                        name="hasGasMeter"
                        value="no"
                        type="radio"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        defaultChecked={hasGasMeter === false}
                      />
                      <label htmlFor="no">Não</label>
                    </SelectorField>
                  </InputsContainer>
                  {isSelected === false && values.hasGasMeter === "" && (
                    <Error>É necessário selecionar uma opção</Error>
                  )}
                  {values.hasGasMeter === "yes" && (
                    <InforCardContact>
                      <ContactCard>
                        <IconContact>
                          <AiTwotoneTool size={52} />
                        </IconContact>
                        <Contacts>
                          <p>
                            A equipe técnica da Ultragaz irá até a sua
                            residência e/ou loja em até três dias úteis
                            (contados a partir da finalização da etapa de
                            cadastro)
                          </p>
                        </Contacts>
                      </ContactCard>
                    </InforCardContact>
                  )}
                  {values.hasGasMeter === "no" && (
                    <InforCardContact>
                      <ContactCard>
                        <IconContact>
                          <MdPermPhoneMsg size={52} />
                        </IconContact>
                        <Contacts>
                          <p>
                            Caso você ainda não tenha o medidor instalado não
                            será possível realizar a liberação do fornecimento
                            do gás.
                          </p>
                          <p>
                            Para mais informações sobre como obter o medidor
                            converse com a Ully, a nossa assistente virtual.
                          </p>
                        </Contacts>
                      </ContactCard>
                    </InforCardContact>
                  )}
                  <Accordion
                    header="Confira informações importantes  para o momento da visita da equipe técnica na sua residência e/ou loja"
                    items={[
                      {
                        title: "Responsável no local",
                        body: (
                          <p>
                            É necessária a presença de um responsável no local
                            para a liberação do acesso ao seu medidor, no dia da
                            visita.
                          </p>
                        ),
                      },
                      {
                        title: "Medidor com avarias",
                        body: (
                          <>
                            <p>
                              Ilegível, embaçado e/ou desprotegidos não poderão
                              ser ligados/religados. Para esses casos será
                              necessário a substituição para um novo equipamento
                              para que o fornecimento de gás seja concluído
                            </p>
                            <p>
                              Para mais informações sobre como obter o medidor
                              converse com a Ully, a nossa assistente virtual.
                            </p>
                          </>
                        ),
                      },
                      {
                        title: "Liberação do gás",
                        body: (
                          <p>
                            Após a visita da equipe técnica, para efetuar o
                            ligue/religue do seu fornecimento de gás, o medidor
                            permanecerá fechado para garantir a sua segurança.
                            Assim que possível, verifique o registro “abre e
                            fecha”, localizado no seu medidor, e libere a
                            passagem do gás.
                          </p>
                        ),
                      },
                    ]}
                  />
                  <ButtonsContainer>
                    <ContainedButton
                      block
                      type="submit"
                      continue
                      id="Avançar"
                      width="100%"
                      TrailingIcon={IoMdArrowForward}
                      propsTrailingIcon={{
                        size: 20,
                      }}
                      disabled={isSelected === false}
                    >
                      Continuar
                    </ContainedButton>
                    <OutlinedButton
                      width="100%"
                      LeadingIcon={IoMdArrowBack}
                      propsLeadingIcon={{
                        size: 20,
                      }}
                      onClick={() => {
                        if (values.hasGasMeter === "yes") {
                          dispatch(
                            registerValuesNewUnit({ hasGasMeter: true })
                          );
                        }

                        if (values.hasGasMeter === "no") {
                          dispatch(
                            registerValuesNewUnit({ hasGasMeter: false })
                          );
                        }

                        dispatch(toggleNewUnitStep(1));
                      }}
                      color={theme.colors.purple}
                    >
                      Voltar
                    </OutlinedButton>
                  </ButtonsContainer>
                </FormContainer>
              )}
            />
          </>
        ) : (
          <Formik
            initialValues={{
              hasGasReleased: hasGasReleased ? "yes" : "no",
            }}
            validationSchema={validatorSchemaGasReleased}
            onSubmit={handleSubmitGasReleased}
            render={({ handleChange, handleBlur }) => (
              <FormContainer>
                <InputsContainer>
                  <SelectorField>
                    <RadioField
                      id="yes"
                      name="hasGasReleased"
                      value="yes"
                      type="radio"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      defaultChecked={hasGasReleased === true}
                    />
                    <label htmlFor="yes">Sim</label>
                  </SelectorField>
                  <SelectorField>
                    <RadioField
                      id="no"
                      name="hasGasReleased"
                      value="no"
                      type="radio"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      defaultChecked={hasGasReleased === false}
                    />
                    <label htmlFor="no">Não</label>
                  </SelectorField>
                </InputsContainer>
                <ButtonsContainer>
                  <ContainedButton
                    block
                    type="submit"
                    continue
                    id="Avançar"
                    width="100%"
                    TrailingIcon={IoMdArrowForward}
                    propsTrailingIcon={{
                      size: 20,
                    }}
                    disabled={isSelected === false}
                  >
                    Continuar
                  </ContainedButton>
                </ButtonsContainer>
              </FormContainer>
            )}
          />
        )}
      </PrimaryColumn>

      <ModalStyle show={isShowModal} centered>
        <ModalContainer>
          <ModalHeader>
            <div>
              <h2>Atenção! Está com o gás liberado?</h2>
            </div>
          </ModalHeader>

          <ModalContent>
            <p>
              Ao informar que “está com acesso ao gás” a Ultragaz não
              encaminhará um técnico para o seu apartamento/loja para realizar o
              ligue gratuitamente.
            </p>
            <p>
              Essa ação impossibilitará a solicitação de religue pelos canais
              digitais e será necessário solicitá-lo pela nossa unidade de
              atendimento ao cliente e será cobrada a taxa de religue no valor
              de R$60,00.
            </p>
            <p>Seu apartamento ou loja está com o gás liberado?</p>

            <Formik
              initialValues={{
                hasGasReleased: hasGasReleased ? "yes1" : "no1",
              }}
              validationSchema={validatorSchemaGasReleased}
              onSubmit={handleSubmitModal}
              render={({ handleChange, handleBlur }) => (
                <FormContainer>
                  <InputsContainer>
                    <SelectorField>
                      <RadioField
                        id="yes1"
                        name="hasGasReleased"
                        value="yes1"
                        type="radio"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        defaultChecked={hasGasReleased === true}
                      />
                      <label htmlFor="yes1">Sim</label>
                    </SelectorField>
                    <SelectorField>
                      <RadioField
                        id="no1"
                        name="hasGasReleased"
                        value="no1"
                        type="radio"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        defaultChecked={hasGasReleased === false}
                      />
                      <label htmlFor="no1">Não</label>
                    </SelectorField>
                  </InputsContainer>
                  <ButtonsContainer>
                    <ContainedButton
                      width="100%"
                      type="submit"
                      LeadingIcon={MdCheck}
                      propsLeadingIcon={{
                        size: 24,
                      }}
                    >
                      Confirmar
                    </ContainedButton>
                  </ButtonsContainer>
                </FormContainer>
              )}
            />
          </ModalContent>
        </ModalContainer>
      </ModalStyle>
    </Container>
  );
};

export default Meter;
